import { useQuery } from '@tanstack/react-query';
import { auth } from '../config/firebase';

interface BillingPageResponse {
  success: boolean;
  hasCustomer: boolean;
  hasSubscription: boolean;
  availableProducts: any[];
  planOptions: {
    monthly: any[];
    yearly: any[];
  };
}

export const useBillingPage = () => {
  return useQuery<BillingPageResponse>({
    queryKey: ['billing-page'],
    staleTime: 5 * 60 * 1000, // Data stays fresh for 5 minutes
    cacheTime: 30 * 60 * 1000, // Cache persists for 30 minutes
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const token = await auth.currentUser?.getIdToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await fetch('https://api.socialness.ai/stripe/billing-page', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          returnUrl: window.location.origin + '/billing'
        })
      });

      if (!response.ok) {
        throw new Error('Failed to fetch billing page data');
      }

      return response.json();
    }
  });
};